/**
 * Функция заменяет парметры в Url для фильтров
 * @param url
 * @param paramName
 * @param value
 * @returns {string}
 */
const replaceAnchorParams = function (url, paramName, value) {
  url = url.split('#')
  if (url[1]) {
    let params = url[1].split('&')
    let isParam = false
    params = params.map(function (item) {
      let origin = item
      let param = item.split('=')
      if (param[0] === paramName) {
        isParam = true
        origin = paramName + '=' + value
      }
      return origin
    })
    if (!isParam) {
      params.push(paramName + '=' + value)
    }
    return url[0] + '#' + params.join('&')
  }

  return url[0] + '#' + paramName + '=' + value
}

export default replaceAnchorParams




// WEBPACK FOOTER //
// ./src/helpers/replaceAnchorParams.js